import { call, put, select } from 'redux-saga/effects';

import { runPathActionsService } from './router';
import {
  fetchAllDevicesRequest,
  fetchCurrentUserRequest,
  fetchNotificationsRequest,
  fetchFactoriesRequest,
  fetchUsersRequest,
  fetchProtocolsRequest,
  fetchItemsRequest,
  fetchModelsRequest,
  fetchAlertsOccurRequest,
  fetchAlertsSettingRequest,
  fetchChannelsRequest,
  fetchDashboardRequest,
  fetchRealtimeDatasRequest,
} from '../requests';
import { pathsMatchSelector } from '../../../selectors';
import { coreInitialized } from '../../../actions';
import i18n from '../../../i18n';

export function* loadLocaleService(language) {
  yield call(i18n.loadCoreLocale, language);
}

export function* initializeCoreService() {
  const {
    payload: {
      user: { isAdmin },
    },
  } = yield call(fetchCurrentUserRequest); // TODO: success check

  if (isAdmin) {
    yield call(fetchUsersRequest);
  }

  yield call(fetchFactoriesRequest);

  const pathsMatch = yield select(pathsMatchSelector);

  yield call(fetchDashboardRequest);
  yield call(fetchAllDevicesRequest);
  yield call(fetchProtocolsRequest);
  yield call(fetchModelsRequest);
  yield call(fetchChannelsRequest);
  yield call(fetchItemsRequest);
  yield call(fetchAlertsSettingRequest);
  yield call(fetchAlertsOccurRequest);
  yield call(fetchNotificationsRequest);
  yield call(fetchRealtimeDatasRequest);
  yield call(runPathActionsService, pathsMatch);
  yield call(loadLocaleService, i18n.language);

  yield put(coreInitialized());
}
